import React from 'react';
import PropTypes from 'prop-types';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Tooltip,
} from '@material-ui/core';
import { formatDateDisplay } from 'utils/dateFunctions';
import { useTranslation } from 'react-i18next';

function ProblemsTabContent({ documents, selectReport }) {
  const { t } = useTranslation('PatientSummary');
  const headers = ['Código', 'Descrição', 'Data'];
  const rows = documents.map((document) => {
    const problem = document.code.coding[0];
    return ({
      id: document.id,
      description: problem?.display,
      code: problem?.code,
      source: document.meta.tag ? document.meta.tag[0].code : document.meta.source,
      date: formatDateDisplay(document.recordedDate),
    });
  });

  return (
    <Table
      size="small"
      aria-label="enhanced table"
    >
      <TableHead>
        <TableRow>
          {headers.map((header, i) => (
            <TableCell
              key={i}
            >
              <h5>
                {header}
              </h5>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {
          rows.map((document) => (
            <Tooltip
              key={document.id}
              placement="top"
              arrow
              title={t('tabsInfo-patientSummary-healthSummary-document-tooltip')}
            >
              <TableRow
                hover
                onClick={() => selectReport(document.source)}
              >
                <TableCell padding="checkbox">{document.code}</TableCell>
                <TableCell>{document.description}</TableCell>
                <TableCell padding="checkbox">{document.date}</TableCell>
              </TableRow>
            </Tooltip>
          ))
        }
      </TableBody>
    </Table>
  );
}

ProblemsTabContent.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  selectReport: PropTypes.func.isRequired,
};

export { ProblemsTabContent };
